import React, { useEffect } from "react";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import TextArea from "../../../../widget/common/form/Textarea";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import {
  ChatsContextImport,
  ChatsContextProvider,
} from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";

const ConversationReportAlert = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <ChatsContextProvider>
      <ConversationReportAlertBody type={type} />
    </ChatsContextProvider>
  );
};

export default ConversationReportAlert;

const ConversationReportAlertBody = (props: { type: number }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const {
    maxWords,
    chatSelected,
    reportMessage,
    submitChatReport,
    reportChangeInput,
    getSelectedChatSession,
  } = ChatsContextImport();

  useEffect(() => {
    getSelectedChatSession();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {chatSelected == null ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <Div>
          <div
            className="font-size-16_17"
            dangerouslySetInnerHTML={{
              __html: AppTranslation.text("report_title"),
            }}
          />
          <div
            className="py-2 font-size-16_17 color-red2 font-gotham-bold"
            dangerouslySetInnerHTML={{
              __html: AppTranslation.text("report_note"),
            }}
          />

          <TextBlock className="mt-2" textColor="primary" fontSize="13_14">
            {AppTranslation.text("mesage")}
          </TextBlock>

          <TextArea
            name="chat-report-message"
            classStyle="px-0"
            rowSize={6}
            maxWords={maxWords}
            placeHolder={AppTranslation.text("type_here_max_200_chars")}
            handleOnChange={reportChangeInput}
            value={reportMessage}
            validate={true}
            error={false}
          />

          <Div className="pt-4 d-center">
            <ButtonSingle
              handleClick={submitChatReport}
              width={type === 3 ? 300 : undefined}
            >
              {AppTranslation.text("submit")}
            </ButtonSingle>
          </Div>
        </Div>
      )}
    </>
  );
};
